import React from 'react';
import { useTranslation } from 'react-i18next';

import { RedButton, GreenButton, PopupButton } from 'components/ActionButtons';
import { displayView } from 'constants/UI';

import Flexbox from './Flexbox';

const MobileView: React.FC = () => {
  const { t } = useTranslation('gridButtons');

  return (
    <>
      <Flexbox>
        <PopupButton
          height={45}
          title={t('saleOptions.title')}
          view={displayView.options}
          removeMargin
        />
        <PopupButton
          height={45}
          title={t('functions.title')}
          view={displayView.functions}
          removeMargin
        />
      </Flexbox>
      <Flexbox>
        <RedButton height={45} width="100%" removeMargin />
        <GreenButton height={45} width="100%" removeMargin />
      </Flexbox>
    </>
  );
};

export default MobileView;
